import { combineReducers } from 'redux';
import tenantsReducer from './tenants';
import sc5ReportReducer from './sc5Report';

const entities = combineReducers({
  tenants: tenantsReducer,
  sc5Report: sc5ReportReducer,
});

export default entities;
